// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Read-only field (used for support email prefilled from URL) */
.NewSignup_readOnlyField__nnxNM {
  padding: 12px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  color: #475569;
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}

/* Invalid / expired support link panel */
.NewSignup_invalidLinkPanel__22Ywi {
  padding: 28px 22px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  text-align: center;
  margin: 12px 0;
}

.NewSignup_invalidLinkIcon__a3a07 {
  font-size: 32px;
  margin-bottom: 10px;
  line-height: 1;
}

.NewSignup_invalidLinkPanel__22Ywi h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #991b1b;
}

.NewSignup_invalidLinkPanel__22Ywi p {
  margin: 0;
  font-size: 13px;
  color: #7f1d1d;
  line-height: 1.6;
  max-width: 380px;
  margin-left: auto;
  margin-right: auto;
}

/* ───────────────────────── Questionnaire Section ───────────────────────── */

/* Outer wrapper card */
.NewSignup_questionnaireSection__GE6kY {
  margin: 24px 0 16px;
  padding: 20px 18px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.NewSignup_questionnaireHeader__ESrc2 {
  margin-bottom: 18px;
}

.NewSignup_questionnaireHeader__ESrc2 h4 {
  margin: 0 0 6px 0;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
}

.NewSignup_questionnaireHeader__ESrc2 p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

/* Inner tile — one per question */
.NewSignup_questionTile__9wC1d {
  padding: 16px 16px 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  margin-bottom: 14px;
}

.NewSignup_questionTile__9wC1d:last-child {
  margin-bottom: 0;
}

/* Label row: label + "See what's included" button side by side */
.NewSignup_questionLabelRow__yzY4V {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
}

.NewSignup_questionLabel__FjGac {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 4px 0;
}

.NewSignup_questionSubtext__dr6WH {
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

/* "See what's included" pill */
.NewSignup_questionInfoBtn__VXOxR {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 500;
  color: #3b82f6;
  background: #f0f7ff;
  border: 1px solid #dbeafe;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  white-space: nowrap;
  margin-top: 2px;
}

.NewSignup_questionInfoBtn__VXOxR:hover {
  background: #e0efff;
  border-color: #bfdbfe;
}

/* Expanded info panel */
.NewSignup_questionInfoPanel__zava0 {
  margin: 10px 0 12px;
  padding: 14px 16px;
  background: #ffffff;
  border: 1px solid #dbeafe;
  border-left: 3px solid #3b82f6;
  border-radius: 8px;
  font-size: 13px;
  color: #334155;
  line-height: 1.6;
  animation: NewSignup_infoFadeIn__GFWAL 0.15s ease;
}

.NewSignup_questionInfoPanel__zava0 p {
  margin: 0 0 8px 0;
}

.NewSignup_questionInfoPanel__zava0 p:last-child {
  margin-bottom: 0;
}

.NewSignup_questionInfoPanel__zava0 ul {
  margin: 6px 0 10px 0;
  padding-left: 18px;
}

.NewSignup_questionInfoPanel__zava0 li {
  margin-bottom: 6px;
}

.NewSignup_questionInfoPanel__zava0 strong {
  color: #1a1a1a;
}

@keyframes NewSignup_infoFadeIn__GFWAL {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Choice cards (radio pills) */
.NewSignup_choiceRow__f5z-w {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.NewSignup_choiceCard__vHxlH {
  flex: 1 1 160px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 10px 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
}

.NewSignup_choiceCard__vHxlH:hover {
  border-color: #94a3b8;
}

.NewSignup_choiceCard__vHxlH input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.NewSignup_choiceCardActive__web5X {
  border-color: #3b82f6;
  background: #f0f7ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.NewSignup_choiceTitle__-wc8l {
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
}

.NewSignup_choiceHint__uivdr {
  font-size: 11px;
  color: #64748b;
  line-height: 1.4;
}

/* Responsive */
@media (max-width: 480px) {
  .NewSignup_choiceRow__f5z-w {
    flex-direction: column;
  }
  .NewSignup_choiceCard__vHxlH {
    flex: 1 1 auto;
  }
  .NewSignup_questionLabelRow__yzY4V {
    flex-direction: column;
    align-items: flex-start;
  }
  .NewSignup_questionInfoBtn__VXOxR {
    align-self: flex-start;
  }
}

.NewSignup_signup__WHBOO {
  width: 50%;
  max-height: 700px;
  max-width: 600px;
  background-color: aliceblue;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.NewSignup_signupWraptab__vVw6n {
  flex-shrink: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #ccc;
}

.NewSignup_signupWraptab__vVw6n h3 {
  text-align: center;
  font-size: 24px;
  color: var(--dark-heading-text);
}

.NewSignup_signupForm__iBK4y {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px 30px 30px 30px;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.NewSignup_formGroup__rZ9GB {
  margin-bottom: 24px;
  width: 100%;
}

.NewSignup_formGroup__rZ9GB label {
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-heading-text);
}

.NewSignup_labelWrapper__WlQel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.NewSignup_fieldIndicator__ZwHM7 {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
}

.NewSignup_fieldIndicator__ZwHM7.NewSignup_updateLater__mchcU {
  background-color: #e8f5e8;
  color: #2e7d32;
  border: 1px solid #c8e6c9;
}

.NewSignup_fieldIndicator__ZwHM7.NewSignup_cannotUpdate__Q1RzT {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ffcdd2;
}

.NewSignup_indicatorIcon__9yO15 {
  font-size: 12px;
}

.NewSignup_exampleButton__BZhDA {
  background: none;
  border: 1px solid #1b5bff;
  color: #1b5bff;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 11px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.NewSignup_exampleButton__BZhDA:hover {
  background-color: #1b5bff;
  color: white;
}

.NewSignup_formGroup__rZ9GB .NewSignup_inputWrapper__mNkmU {
  position: relative;
}

.NewSignup_phone-input-container__ucBQj {
  width: 100%;
  display: flex;
}

.NewSignup_phone-input-container__ucBQj .NewSignup_phone-input__oM81P {
  width: 100%;
  height: 50px;
  background: var(--seconadry-ic-bg);
  position: relative;
  outline: none;
  border: none;
}

.NewSignup_phone-input-container__ucBQj .NewSignup_phone-input-wrapper__XCI-G {
  position: relative;
}

.NewSignup_phone-input-container__ucBQj .NewSignup_phone-input__oM81P:focus {
  border: 1px solid var(--seconadry-color);
  color: black;
}

.NewSignup_phone-input__oM81P {
  width: 100% !important;
  flex: 1 1;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.NewSignup_phone-input-container__ucBQj .NewSignup_flag-dropdown__\\+78Bi {
  margin-right: 8px;
}

.NewSignup_formGroup__rZ9GB select {
  width: 100%;
  padding: 16px;
  font-size: 14px;
  font-weight: 600;
  background: var(--seconadry-ic-bg);
  color: var(--text-color);
  border: none;
  border-radius: 8px;
  outline: none;
  appearance: none;
  cursor: pointer;
}

.NewSignup_attchmentWrap__qZowU {
  border: 2px solid;
  border-style: dashed;
  border-color: #a370ce;
  border-radius: 6px;
  background-color: var(--seconadry-ic-bg);
  transition: all 0.3s ease;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.NewSignup_attchmentWrap__qZowU:hover {
  background-color: #e8e2f5;
}

.NewSignup_fileName__NxAKf {
  text-align: center;
  /* margin-bottom: 15px; */
  padding: 0 10px;
  font-size: 14px;
  color: var(--seconadry-color);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

input[type="file"] {
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
}

.NewSignup_checkboxWrapper__vdjug {
  display: flex;
  align-items: flex-start;
}

.NewSignup_checkboxWrapper__vdjug input[type="checkbox"] {
  margin-right: 10px;
  width: 22px;
  height: 22px;
  margin-top: 2px;
}

.NewSignup_checkboxWrapper__vdjug span {
  font-size: 16px;
  color: var(--dark-heading-text);
  line-height: 1.4;
}

.NewSignup_checkboxWrapper__vdjug a {
  color: var(--seconadry-color);
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.NewSignup_checkboxWrapper__vdjug a:hover {
  text-decoration: underline;
}

/* File Upload Field */
.NewSignup_formGroup__rZ9GB label[for="file"] {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  /* padding: 16px 20px 0px 20px; */
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color);
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s;
  text-align: center;
}

.NewSignup_formGroup__rZ9GB label[for="file"]:active {
  background-color: var(--seconadry-color-dark);
  color: #fff;
}

.NewSignup_fileIcon__oTg1z {
  font-size: 24px;
  color: var(--text-color);
  transition: color 0.3s;
}

/* Example Popup Styles */
.NewSignup_examplePopupOverlay__rmA4E {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.NewSignup_examplePopup__ca2RN {
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.NewSignup_popupHeader__PFHjO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background: var(--body-bg-color);
}

.NewSignup_popupHeader__PFHjO h3 {
  margin: 0;
  color: var(--dark-heading-text);
  font-size: 20px;
}

.NewSignup_closeButton__-cTzT {
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.NewSignup_closeButton__-cTzT:hover {
  background-color: #f0f0f0;
  color: #333;
}

.NewSignup_popupContent__ncLin {
  padding: 20px;
  text-align: center;
}

.NewSignup_exampleImage__WToQ8 {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 15px;
  border: 1px solid #e0e0e0;
}

.NewSignup_popupContent__ncLin p {
  color: var(--text-color);
  line-height: 1.5;
  margin: 0;
  font-size: 14px;
}

/* Tabs */
.NewSignup_tabsWrapper__QtZ54 {
  display: flex;
  margin-top: 20px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.NewSignup_tabButton__5-Rg4 {
  flex: 1 1;
  background: none;
  border: none;
  padding: 14px 0;
  font-size: 16px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  background-color: #eaeaea;
}

.NewSignup_activeTab__Tq1td {
  color: white;
  font-weight: 600;
  background-color: #0070f3;
}

/* Mobile Responsive */
@media (min-width: 1025px) and (max-width: 1168px) {
  .NewSignup_cannotUpdate__Q1RzT {
    max-width: 180px;
  }
  .NewSignup_cannotUpdate__Q1RzT .NewSignup_indicatorIcon__9yO15 {
    font-size: 20px;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .NewSignup_loginContainer__YMB33 {
    padding: 4rem 8rem;
  }

  .NewSignup_loginContent__9E\\+2n {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px;
  }

  .NewSignup_login_left__tfsgn {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 30px;
  }

  .NewSignup_login_left__tfsgn h1 {
    font-size: 50px;
  }

  .NewSignup_login__98yuM p {
    font-size: 18px;
  }

  .NewSignup_signup__WHBOO {
    width: 100%;
  }

  .NewSignup_labelWrapper__WlQel {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 8px;
  }
}

@media (min-width: 369px) and (max-width: 768px) {
  .NewSignup_loginContainer__YMB33 {
    padding: 4rem;
  }

  .NewSignup_loginContent__9E\\+2n {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px;
  }

  .NewSignup_login_left__tfsgn {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 30px;
  }

  .NewSignup_login_left__tfsgn h1 {
    font-size: 50px;
  }

  .NewSignup_login__98yuM p {
    font-size: 18px;
  }

  .NewSignup_signup__WHBOO {
    width: 100%;
  }

  .NewSignup_labelWrapper__WlQel {
    /* flex-direction: column; */
    align-items: flex-start;
    gap: 8px;
  }

  .NewSignup_examplePopup__ca2RN {
    max-width: 95%;
  }
}

@media (max-width: 368px) {
  .NewSignup_signup__WHBOO {
    width: 100%;
    padding: 0px;
    margin: 0px;
    box-shadow: none;
    max-height: 89vh;
  }

  .NewSignup_signupWraptab__vVw6n {
    padding: 0px;
    border-bottom: 0px;
  }
  .NewSignup_signupWraptab__vVw6n h3 {
    margin-bottom: 0px;
  }
  .NewSignup_signupForm__iBK4y {
    padding: 0px 0px 20px 0px;
    margin-bottom: 50px;
  }

  .NewSignup_labelWrapper__WlQel {
    /* flex-direction: column; */
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  .NewSignup_labelWrapper__WlQel .NewSignup_fieldIndicator__ZwHM7 {
    background-color: transparent;
    border: none;
    padding: 0px;
  }
  .NewSignup_formGroup__rZ9GB label {
    margin-bottom: 0px;
    font-size: 14px;
    font-weight: 500;
  }
  .NewSignup_tabButton__5-Rg4 {
    padding: 8px 0px;
  }

  .NewSignup_examplePopup__ca2RN {
    max-width: 95%;
    margin: 10px;
  }

  .NewSignup_popupHeader__PFHjO {
    padding: 15px;
  }

  .NewSignup_popupContent__ncLin {
    padding: 15px;
  }
  .NewSignup_exampleButton__BZhDA {
    border: none;
    border-bottom: 1px solid var(--primary-color);
    border-radius: 0px;
    padding: 0px;
  }
  .NewSignup_exampleButton__BZhDA:hover {
    background: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Auth/NewSignup/NewSignup.module.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8EAA8E;;AAE9E,uBAAuB;AACvB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iDAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf;;cAEY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;EACV;EACA;IACE,6BAA6B;IAC7B,YAAY;IACZ,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,6CAA6C;IAC7C,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Read-only field (used for support email prefilled from URL) */\n.readOnlyField {\n  padding: 12px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #475569;\n  cursor: not-allowed;\n  user-select: none;\n}\n\n/* Invalid / expired support link panel */\n.invalidLinkPanel {\n  padding: 28px 22px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  text-align: center;\n  margin: 12px 0;\n}\n\n.invalidLinkIcon {\n  font-size: 32px;\n  margin-bottom: 10px;\n  line-height: 1;\n}\n\n.invalidLinkPanel h4 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #991b1b;\n}\n\n.invalidLinkPanel p {\n  margin: 0;\n  font-size: 13px;\n  color: #7f1d1d;\n  line-height: 1.6;\n  max-width: 380px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* ───────────────────────── Questionnaire Section ───────────────────────── */\n\n/* Outer wrapper card */\n.questionnaireSection {\n  margin: 24px 0 16px;\n  padding: 20px 18px 14px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.questionnaireHeader {\n  margin-bottom: 18px;\n}\n\n.questionnaireHeader h4 {\n  margin: 0 0 6px 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.questionnaireHeader p {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n/* Inner tile — one per question */\n.questionTile {\n  padding: 16px 16px 14px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  margin-bottom: 14px;\n}\n\n.questionTile:last-child {\n  margin-bottom: 0;\n}\n\n/* Label row: label + \"See what's included\" button side by side */\n.questionLabelRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 4px;\n}\n\n.questionLabel {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0 0 4px 0;\n}\n\n.questionSubtext {\n  margin: 4px 0 0 0;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n/* \"See what's included\" pill */\n.questionInfoBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #3b82f6;\n  background: #f0f7ff;\n  border: 1px solid #dbeafe;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n  white-space: nowrap;\n  margin-top: 2px;\n}\n\n.questionInfoBtn:hover {\n  background: #e0efff;\n  border-color: #bfdbfe;\n}\n\n/* Expanded info panel */\n.questionInfoPanel {\n  margin: 10px 0 12px;\n  padding: 14px 16px;\n  background: #ffffff;\n  border: 1px solid #dbeafe;\n  border-left: 3px solid #3b82f6;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #334155;\n  line-height: 1.6;\n  animation: infoFadeIn 0.15s ease;\n}\n\n.questionInfoPanel p {\n  margin: 0 0 8px 0;\n}\n\n.questionInfoPanel p:last-child {\n  margin-bottom: 0;\n}\n\n.questionInfoPanel ul {\n  margin: 6px 0 10px 0;\n  padding-left: 18px;\n}\n\n.questionInfoPanel li {\n  margin-bottom: 6px;\n}\n\n.questionInfoPanel strong {\n  color: #1a1a1a;\n}\n\n@keyframes infoFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-3px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Choice cards (radio pills) */\n.choiceRow {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.choiceCard {\n  flex: 1 1 160px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 10px 14px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  position: relative;\n}\n\n.choiceCard:hover {\n  border-color: #94a3b8;\n}\n\n.choiceCard input[type=\"radio\"] {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.choiceCardActive {\n  border-color: #3b82f6;\n  background: #f0f7ff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);\n}\n\n.choiceTitle {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.choiceHint {\n  font-size: 11px;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .choiceRow {\n    flex-direction: column;\n  }\n  .choiceCard {\n    flex: 1 1 auto;\n  }\n  .questionLabelRow {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .questionInfoBtn {\n    align-self: flex-start;\n  }\n}\n\n.signup {\n  width: 50%;\n  max-height: 700px;\n  max-width: 600px;\n  background-color: aliceblue;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.signupWraptab {\n  flex-shrink: 0;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n}\n\n.signupWraptab h3 {\n  text-align: center;\n  font-size: 24px;\n  color: var(--dark-heading-text);\n}\n\n.signupForm {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 30px 30px 30px;\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n\n.formGroup {\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--dark-heading-text);\n}\n\n.labelWrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.fieldIndicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-weight: 500;\n}\n\n.fieldIndicator.updateLater {\n  background-color: #e8f5e8;\n  color: #2e7d32;\n  border: 1px solid #c8e6c9;\n}\n\n.fieldIndicator.cannotUpdate {\n  background-color: #ffebee;\n  color: #c62828;\n  border: 1px solid #ffcdd2;\n}\n\n.indicatorIcon {\n  font-size: 12px;\n}\n\n.exampleButton {\n  background: none;\n  border: 1px solid #1b5bff;\n  color: #1b5bff;\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 11px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.exampleButton:hover {\n  background-color: #1b5bff;\n  color: white;\n}\n\n.formGroup .inputWrapper {\n  position: relative;\n}\n\n.phone-input-container {\n  width: 100%;\n  display: flex;\n}\n\n.phone-input-container .phone-input {\n  width: 100%;\n  height: 50px;\n  background: var(--seconadry-ic-bg);\n  position: relative;\n  outline: none;\n  border: none;\n}\n\n.phone-input-container .phone-input-wrapper {\n  position: relative;\n}\n\n.phone-input-container .phone-input:focus {\n  border: 1px solid var(--seconadry-color);\n  color: black;\n}\n\n.phone-input {\n  width: 100% !important;\n  flex: 1;\n  padding: 12px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.phone-input-container .flag-dropdown {\n  margin-right: 8px;\n}\n\n.formGroup select {\n  width: 100%;\n  padding: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  background: var(--seconadry-ic-bg);\n  color: var(--text-color);\n  border: none;\n  border-radius: 8px;\n  outline: none;\n  appearance: none;\n  cursor: pointer;\n}\n\n.attchmentWrap {\n  border: 2px solid;\n  border-style: dashed;\n  border-color: #a370ce;\n  border-radius: 6px;\n  background-color: var(--seconadry-ic-bg);\n  transition: all 0.3s ease;\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n\n.attchmentWrap:hover {\n  background-color: #e8e2f5;\n}\n\n.fileName {\n  text-align: center;\n  /* margin-bottom: 15px; */\n  padding: 0 10px;\n  font-size: 14px;\n  color: var(--seconadry-color);\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\ninput[type=\"file\"] {\n  visibility: hidden;\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n\n.checkboxWrapper {\n  display: flex;\n  align-items: flex-start;\n}\n\n.checkboxWrapper input[type=\"checkbox\"] {\n  margin-right: 10px;\n  width: 22px;\n  height: 22px;\n  margin-top: 2px;\n}\n\n.checkboxWrapper span {\n  font-size: 16px;\n  color: var(--dark-heading-text);\n  line-height: 1.4;\n}\n\n.checkboxWrapper a {\n  color: var(--seconadry-color);\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.checkboxWrapper a:hover {\n  text-decoration: underline;\n}\n\n/* File Upload Field */\n.formGroup label[for=\"file\"] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  /* padding: 16px 20px 0px 20px; */\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-color);\n  cursor: pointer;\n  transition:\n    background-color 0.3s,\n    color 0.3s;\n  text-align: center;\n}\n\n.formGroup label[for=\"file\"]:active {\n  background-color: var(--seconadry-color-dark);\n  color: #fff;\n}\n\n.fileIcon {\n  font-size: 24px;\n  color: var(--text-color);\n  transition: color 0.3s;\n}\n\n/* Example Popup Styles */\n.examplePopupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.examplePopup {\n  background: white;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.popupHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: var(--body-bg-color);\n}\n\n.popupHeader h3 {\n  margin: 0;\n  color: var(--dark-heading-text);\n  font-size: 20px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #666;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.closeButton:hover {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.popupContent {\n  padding: 20px;\n  text-align: center;\n}\n\n.exampleImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  border: 1px solid #e0e0e0;\n}\n\n.popupContent p {\n  color: var(--text-color);\n  line-height: 1.5;\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Tabs */\n.tabsWrapper {\n  display: flex;\n  margin-top: 20px;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.tabButton {\n  flex: 1 1;\n  background: none;\n  border: none;\n  padding: 14px 0;\n  font-size: 16px;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: center;\n  background-color: #eaeaea;\n}\n\n.activeTab {\n  color: white;\n  font-weight: 600;\n  background-color: #0070f3;\n}\n\n/* Mobile Responsive */\n@media (min-width: 1025px) and (max-width: 1168px) {\n  .cannotUpdate {\n    max-width: 180px;\n  }\n  .cannotUpdate .indicatorIcon {\n    font-size: 20px;\n  }\n}\n@media (min-width: 769px) and (max-width: 1024px) {\n  .loginContainer {\n    padding: 4rem 8rem;\n  }\n\n  .loginContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 0px;\n  }\n\n  .login_left {\n    width: 100%;\n    margin-right: 0px;\n    margin-bottom: 30px;\n  }\n\n  .login_left h1 {\n    font-size: 50px;\n  }\n\n  .login p {\n    font-size: 18px;\n  }\n\n  .signup {\n    width: 100%;\n  }\n\n  .labelWrapper {\n    /* flex-direction: column; */\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n@media (min-width: 369px) and (max-width: 768px) {\n  .loginContainer {\n    padding: 4rem;\n  }\n\n  .loginContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 0px;\n  }\n\n  .login_left {\n    width: 100%;\n    margin-right: 0px;\n    margin-bottom: 30px;\n  }\n\n  .login_left h1 {\n    font-size: 50px;\n  }\n\n  .login p {\n    font-size: 18px;\n  }\n\n  .signup {\n    width: 100%;\n  }\n\n  .labelWrapper {\n    /* flex-direction: column; */\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .examplePopup {\n    max-width: 95%;\n  }\n}\n\n@media (max-width: 368px) {\n  .signup {\n    width: 100%;\n    padding: 0px;\n    margin: 0px;\n    box-shadow: none;\n    max-height: 89vh;\n  }\n\n  .signupWraptab {\n    padding: 0px;\n    border-bottom: 0px;\n  }\n  .signupWraptab h3 {\n    margin-bottom: 0px;\n  }\n  .signupForm {\n    padding: 0px 0px 20px 0px;\n    margin-bottom: 50px;\n  }\n\n  .labelWrapper {\n    /* flex-direction: column; */\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n  }\n  .labelWrapper .fieldIndicator {\n    background-color: transparent;\n    border: none;\n    padding: 0px;\n  }\n  .formGroup label {\n    margin-bottom: 0px;\n    font-size: 14px;\n    font-weight: 500;\n  }\n  .tabButton {\n    padding: 8px 0px;\n  }\n\n  .examplePopup {\n    max-width: 95%;\n    margin: 10px;\n  }\n\n  .popupHeader {\n    padding: 15px;\n  }\n\n  .popupContent {\n    padding: 15px;\n  }\n  .exampleButton {\n    border: none;\n    border-bottom: 1px solid var(--primary-color);\n    border-radius: 0px;\n    padding: 0px;\n  }\n  .exampleButton:hover {\n    background: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"readOnlyField": `NewSignup_readOnlyField__nnxNM`,
	"invalidLinkPanel": `NewSignup_invalidLinkPanel__22Ywi`,
	"invalidLinkIcon": `NewSignup_invalidLinkIcon__a3a07`,
	"questionnaireSection": `NewSignup_questionnaireSection__GE6kY`,
	"questionnaireHeader": `NewSignup_questionnaireHeader__ESrc2`,
	"questionTile": `NewSignup_questionTile__9wC1d`,
	"questionLabelRow": `NewSignup_questionLabelRow__yzY4V`,
	"questionLabel": `NewSignup_questionLabel__FjGac`,
	"questionSubtext": `NewSignup_questionSubtext__dr6WH`,
	"questionInfoBtn": `NewSignup_questionInfoBtn__VXOxR`,
	"questionInfoPanel": `NewSignup_questionInfoPanel__zava0`,
	"infoFadeIn": `NewSignup_infoFadeIn__GFWAL`,
	"choiceRow": `NewSignup_choiceRow__f5z-w`,
	"choiceCard": `NewSignup_choiceCard__vHxlH`,
	"choiceCardActive": `NewSignup_choiceCardActive__web5X`,
	"choiceTitle": `NewSignup_choiceTitle__-wc8l`,
	"choiceHint": `NewSignup_choiceHint__uivdr`,
	"signup": `NewSignup_signup__WHBOO`,
	"signupWraptab": `NewSignup_signupWraptab__vVw6n`,
	"signupForm": `NewSignup_signupForm__iBK4y`,
	"formGroup": `NewSignup_formGroup__rZ9GB`,
	"labelWrapper": `NewSignup_labelWrapper__WlQel`,
	"fieldIndicator": `NewSignup_fieldIndicator__ZwHM7`,
	"updateLater": `NewSignup_updateLater__mchcU`,
	"cannotUpdate": `NewSignup_cannotUpdate__Q1RzT`,
	"indicatorIcon": `NewSignup_indicatorIcon__9yO15`,
	"exampleButton": `NewSignup_exampleButton__BZhDA`,
	"inputWrapper": `NewSignup_inputWrapper__mNkmU`,
	"phone-input-container": `NewSignup_phone-input-container__ucBQj`,
	"phone-input": `NewSignup_phone-input__oM81P`,
	"phone-input-wrapper": `NewSignup_phone-input-wrapper__XCI-G`,
	"flag-dropdown": `NewSignup_flag-dropdown__+78Bi`,
	"attchmentWrap": `NewSignup_attchmentWrap__qZowU`,
	"fileName": `NewSignup_fileName__NxAKf`,
	"checkboxWrapper": `NewSignup_checkboxWrapper__vdjug`,
	"fileIcon": `NewSignup_fileIcon__oTg1z`,
	"examplePopupOverlay": `NewSignup_examplePopupOverlay__rmA4E`,
	"examplePopup": `NewSignup_examplePopup__ca2RN`,
	"popupHeader": `NewSignup_popupHeader__PFHjO`,
	"closeButton": `NewSignup_closeButton__-cTzT`,
	"popupContent": `NewSignup_popupContent__ncLin`,
	"exampleImage": `NewSignup_exampleImage__WToQ8`,
	"tabsWrapper": `NewSignup_tabsWrapper__QtZ54`,
	"tabButton": `NewSignup_tabButton__5-Rg4`,
	"activeTab": `NewSignup_activeTab__Tq1td`,
	"loginContainer": `NewSignup_loginContainer__YMB33`,
	"loginContent": `NewSignup_loginContent__9E+2n`,
	"login_left": `NewSignup_login_left__tfsgn`,
	"login": `NewSignup_login__98yuM`
};
export default ___CSS_LOADER_EXPORT___;
